module.exports = __webpack_public_path__ + "images/mourik_smalldb5170d71e6e413a7b174528d9d02d71.png";